import { render, staticRenderFns } from "./NoterSenediAlacakFormWizard.vue?vue&type=template&id=35855571"
import script from "./NoterSenediAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./NoterSenediAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports